//Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzButton, BzMasterAgGrid, BzTab, BzTabs } from '../../../components';

import { convertColumnsDatatoGridColumns, convertTOVariable, deepClone, displayZeroStateForGrid, getMktSegIdFromApiExchangeName, handleScripUnsubScriptionOnUnMount, ORDERS_GRID_REF } from '../../../utils/global_functions';
import { GRID_ROW_SELECTION_TYPE, MANAGE_COLUMNS_VIEW_TYPES, MARKET_SEGMENT_ID, ORDER_TYPES, ORDERBOOK_API_ORDER_STATUS, ORDERS_LIMIT_IN_API, ORDERS_TABKEY, setStrSearch, strSearch, TL_INDEX, WATCHLIST_GRID_INDEX } from '../../../utils/global_variables';
import OrdersPopover from '../OrdersPopover';
import OrderSymbolColumn from '../OrderSymbolColumn';
import StatusChip from '../StatusChip';
import { sendTouchlineRequest } from '../../../apis/web_socket';
import moment from 'moment';
import { useDebounce, useUnload, useWFHMessages } from '../../../hooks';
import { getWfhTouchlineLastTick } from '../../../redux/actions/wfh';
import { _getGtdOrdersHistory, _getOrderDisplayStatus } from '../../../controllers/orders';
import { handleModal, handleModalData } from '../../../redux/actions/modals';
import { getAllGtdOrders, getScripOrderInfo, setCurrentPage } from '../../../redux/actions/orders';
import useAnalyticsEventTracker from '../../../hooks/useAnalyticsEventTracker';
import GridHeaderSearch from '../../GridHeaderSearch';
import ZeroStates from '../../ZeroStates';
import { LoginLoader } from '../../Login';

let bIsApiFiring = false;



const GTD = ({ onTabChange, ordersTabKey, activeContent, onCancelOrder, isButtonDisabled, onSquareOffClick, isRowSelectable, onRowSelected, ...props }) => {


    const isExternalFilterPresent = useCallback(() => {
        return strSearch !== null;
    }, []);
    const onChangeGridHeaderSearch = useCallback(() => {
        const value = document.getElementById('orders_header_search').value;
        setStrSearch(value);
        ORDERS_GRID_REF?.current?.api?.onFilterChanged();
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- Start
        displayZeroStateForGrid(ORDERS_GRID_REF);
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- End
    }, []);
    const sortingComparator = useCallback((number1, number2) => {
        number1 = parseFloat(number1);
        number2 = parseFloat(number2);
        if (number1 === null) {
            return 0.00;
        }
        if (number2 === null) {
            return 0.00;
        }
        return number1 - number2;
    }, []);

    const objPriceGridFilterProps = {
        filter: 'agTextColumnFilter',
        filterParams: {
            textMatcher: ({ filterOption, value, filterText, data, filterTo, ...props }) => {

                if (filterText == null) {
                    return false;
                } else {
                    switch (filterOption) {
                        case 'equals': {
                            return parseFloat(filterText) === parseFloat(value);
                        }
                        case 'notEqual': {
                            return parseFloat(filterText) !== parseFloat(value);
                        }
                        case 'lessThan': {
                            return parseFloat(value) < parseFloat(filterText);
                        }
                        case 'lessThanOrEqual': {
                            return parseFloat(value) <= parseFloat(filterText);
                        }
                        case 'greaterThan': {
                            return parseFloat(value) > parseFloat(filterText);
                        }
                        case 'greaterThanOrEqual': {
                            return parseFloat(value) >= parseFloat(filterText);
                        }
                        case 'inRange': {
                            const agFilterModel = ORDERS_GRID_REF?.current?.api?.getFilterModel()[WATCHLIST_GRID_INDEX?.LAST_TRADE_PRICE?.toString()];
                            if (Object?.keys(agFilterModel)?.length > 0) {
                                const fromValue = agFilterModel?.filter;
                                const toValue = agFilterModel?.filterTo;
                                return parseFloat(value) >= parseFloat(fromValue) && parseFloat(value) <= parseFloat(toValue);
                            } else {
                                return false;
                            }
                        }
                        case 'blank': {
                            return false;
                        }
                        case 'notBlank': {
                            return true;
                        }
                        default:
                            return false;
                    }
                }
            },
            filterOptions: [
                'greaterThanOrEqual',
                'greaterThan',
                'equals',
                'notEqual',
                'lessThanOrEqual',
                'lessThan',
                'inRange',
                'blank',
                'notBlank'
            ]
        }, comparator: sortingComparator,
    };


    // Ameersha N : 08-11-2023 : BT-95888 create watchlist– Issue -reordering scrips fix when filtered  – Start
    const doesExternalFilterPass = useCallback((node) => {
        if (strSearch) {
            const keywords = strSearch?.toUpperCase()?.split(' ');
            const strExchange = node?.data?.exchange?.split('_')[0];
            const strRowScrip = node?.data?.symbol + strExchange + node?.data?.series;
            const rowData = strRowScrip?.split(' ')?.join('')?.toUpperCase();
            return keywords?.every(keyword => rowData?.includes(keyword));
        } else {
            return true;
        }
    }, []);

    const dispatch = useDispatch();
    const gtdColdef = useSelector(state => state.orders.gtdColdef);
    const gtdAllOrders = useSelector(state => state.orders.gtdOrders);
    const gtdOpenOrders = useSelector(state => state.orders.gtdOpenOrders);
    const gtdCompletedOrders = useSelector(state => state.orders.gtdCompletedOrders);
    const objGTDMetaData = useSelector(state => state.orders.objGTDMetaData);
    const bIsOrderApiPending = useSelector(state => state?.orders?.bIsOrderApiPending);
    const nCurrentPage = useSelector(state => state.orders.nCurrentPage);
    const [nGridHeight, setNGridHeight] = useState(0);

    const userColumnProfiles = useSelector(state => state?.watchList?.userColumnProfiles);
    const objViewWiseColumnProfiles = useSelector(state => state.watchList.objViewWiseColumnProfiles);
    const GTDTenantColumnProfiles = useMemo(() => {
        const GTDColumDetails = deepClone(userColumnProfiles)?.find(eachProfile => eachProfile?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.ORDER_GOOD_TILL_DATE_VIEW_TYPE?.toLowerCase() && eachProfile?.bIsDefault);
        let settings = {};
        if (GTDColumDetails) {
            const updatedColumnDetails = deepClone(GTDColumDetails?.columnDetails)?.map((eachProfile) => {
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                } else {
                    settings = { ...eachProfile?.sSettings };
                }
                eachProfile.sSettings = { ...settings, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            return convertColumnsDatatoGridColumns(updatedColumnDetails);
        } else {
            const updatedColumnDetails = objViewWiseColumnProfiles[MANAGE_COLUMNS_VIEW_TYPES.ORDER_GOOD_TILL_DATE_VIEW_TYPE]?.map((eachProfile) => {
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                } else {
                    settings = { ...eachProfile?.sSettings };
                }
                eachProfile.sSettings = { ...settings, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            const arrdDefaultColumns = updatedColumnDetails?.filter(eachColumn => eachColumn?.sSettings?.bIsFixed === "true" || eachColumn?.sSettings?.bIsDefault === "true");
            return convertColumnsDatatoGridColumns(arrdDefaultColumns);
        }
    }, [userColumnProfiles, objViewWiseColumnProfiles]);
    const getRowId = useCallback((params) => {
        if (params?.data) {
            return params?.data?.order_id;
        } else { }
    }, []);

    const arrColDef = useMemo(() => {
        if (GTDTenantColumnProfiles?.length > 0) {
            const arrOrderColumnDefs = GTDTenantColumnProfiles?.map((item) => {
                switch (item.field) {
                    case 'title':
                        item = {
                            ...item,
                            pinned: 'left',
                            suppressMovable: true,
                            lockPosition: "left",
                            suppressNavigable: true,
                            headerComponent: GridHeaderSearch,
                            headerComponentParams: { onChangeGridHeaderSearch, gridRef: ORDERS_GRID_REF },
                            cellRendererParams: (() => ({ placement: 'right' })),
                            cellRenderer: ({ data: objRowData, value, ...props }) =>
                                <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                                    <OrderSymbolColumn objRowData={objRowData} {...props} />
                                </OrdersPopover>, width: 350,
                        };
                        return item;
                    case 'order_timestamp':
                        item = {
                            ...item,
                            // pinned: 'left',
                            suppressMovable: true,
                            // lockPosition: "left",
                            suppressNavigable: true,
                            filter: 'agDateColumnFilter', filterParams: {
                                comparator: (dateFromFilter, cellValue) => {
                                    if (cellValue === null) { return -1; }
                                    const dateParts = moment(cellValue).format('DD/MM/YYYY')?.split('/');
                                    const cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
                                    if (dateFromFilter?.getTime() === cellDate?.getDate()) {
                                        return 0;
                                    }
                                    if (cellDate < dateFromFilter) {
                                        return -1;
                                    } else
                                        if (cellDate > dateFromFilter) {
                                            return 1;
                                        }
                                    return 0;
                                }
                            }, pinned: 'left',
                            cellRenderer: ({ data: objRowData, value, ...props }) =>
                                <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                                    {/* {moment(value).format("hh:mm:ss A, DD MMM 'YY")} */}
                                    {/* {convertTo12HourFormat(element.order_timestamp.split(" ")[1])} */}
                                    {/* Azeem K : 14-12-2023 :BT-120115 - Breeze - Order Book - Good Till Date - Start  */}
                                    {value}
                                    {/* Azeem K : 14-12-2023 :BT-120115 - Breeze - Order Book - Good Till Date - Start  */}
                                </OrdersPopover>
                        };
                        return item;

                    case 'transaction_type':
                        item = {
                            ...item, cellClassRules: {
                                'color-positive': params => params?.value?.toUpperCase() === 'BUY',
                                'color-negative': params => params?.value?.toUpperCase() === 'SELL'
                            }, cellRenderer: ({ data: objRowData, value, ...props }) =>
                                <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                                    {value}
                                </OrdersPopover>
                        };
                        return item;

                    case 'displayQty': //Azeem K : 16-12-2023 :BT-120115 - Breeze - Order Book - Good Till Date  : change  column name 
                        item = {
                            ...item, cellRenderer: ({ data: objRowData, value, ...props }) =>
                                <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                                    {/* Azeem K : 14-12-2023 :BT-120115 - Breeze - Order Book - Good Till Date - Start  */}
                                    {value}
                                    {/* Azeem K : 14-12-2023 :BT-120115 - Breeze - Order Book - Good Till Date - End  */}

                                </OrdersPopover>
                        };
                        return item;
                    case 'status':
                        item = {
                            ...item, cellRenderer: ({ data: objRowData, value, ...props }) =>
                                <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                                    <StatusChip data={objRowData} bisEnlargementClass={true} />
                                </OrdersPopover>,
                            valueGetter: (params) => _getOrderDisplayStatus(params?.data?.status), // Azeem K : 11-12-2023 :added orderStatus
                        };
                        return item;
                    case 'validity_date':
                        item = {
                            ...item, cellRenderer: ({ data: objRowData, value, ...props }) =>
                                <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                                    {/* {moment(value).format("DD MMM 'YY")} */}
                                    {/* Azeem K : 14-12-2023 :BT-120115 - Breeze - Order Book - Good Till Date - Start  */}
                                    {value}
                                    {/* Azeem K : 14-12-2023 :BT-120115 - Breeze - Order Book - Good Till Date - End  */}
                                </OrdersPopover>
                        };
                        return item;
                    default:
                        item = {
                            ...item, cellRenderer: ({ data: objRowData, value, ...props }) =>
                                <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                                    {value}
                                </OrdersPopover>,
                            ...objPriceGridFilterProps
                        };
                        return item;
                }
            });

            const objChecboxColumn = [{
                colId: "check",
                hide: true,
                headerCheckboxSelection: true,
                checkboxSelection: true,
                showDisabledCheckboxes: true,
                pinned: 'left',
                width: '40'
            }, {
                headerName: "", field: "expandCell",
                cellRenderer: 'agGroupCellRenderer',
                pinned: 'left',
                width: '50',
                maxWidth: 50,
                detailCellRendererParams: { placement: 'right' },
                pinned: 'left',
                suppressMovable: true,
                lockPosition: "left",
                suppressNavigable: true,
                menuTabs: [],
                cellStyle: { display: "flex", alignItems: "center", justifyContent: "center" }
            }];
            return [...objChecboxColumn, ...arrOrderColumnDefs];
        } else {
            return [];
        }
    }, [GTDTenantColumnProfiles, activeContent]);
    const selectionColumnDef = useMemo(() => {
        return {
            pinned: 'left',
            hide: true,
        };
    }, []);

    const rowSelection = useMemo(() => {
        return {
            mode: GRID_ROW_SELECTION_TYPE.SINGLE_ROW,
            checkboxes: true
        };
    }, []);
    const getEvent = useAnalyticsEventTracker('ORDERBOOK');

    const arrRowData = useMemo(() => {
        switch (ordersTabKey) {
            case ORDERS_TABKEY.ALL_ORDERS: {
                getEvent('GOOD TILL DATE_ALL_ORDERS');
                return gtdAllOrders;
            }
            case ORDERS_TABKEY.OPEN_ORDERS: {
                getEvent('GOOD TILL DATE_OPEN_ORDERS');
                return gtdOpenOrders;
            }
            case ORDERS_TABKEY.COMPLETED_ORDERS: {
                getEvent('GOOD TILL DATE_COMPLETED_ORDERS');
                return gtdCompletedOrders;
            }
            default: {
                return [];
            }
        }
    }, [ordersTabKey, gtdAllOrders, gtdCompletedOrders, gtdOpenOrders]);

    const detailCellRendererParams = useMemo(() => {
        return {
            detailGridOptions: {
                rowSelection: 'multiple',
                suppressRowClickSelection: true,
                enableRangeSelection: false,
                pagination: false,
                paginationAutoPageSize: false,
                columnDefs: [
                    { field: 'order_date', headerName: "Trade Timestamp", valueFormatter: params => moment(params.value).format("hh:mm a, DD MMM 'YY") },
                    { field: 'gtd_order_id', headerName: "Trade No." },
                    { field: 'traded_quantity', headerName: 'Trade Qty', minWidth: 150 },
                    { field: 'order_price', headerName: "Trade Price" },
                ],
                defaultColDef: {
                    flex: 1,
                    suppressMovable: true,
                    lockPosition: 'left',
                    suppressNavigable: true,
                },
            },
            getDetailRowData: (params) => {
                let temp = params?.data?.trades;//[]
                // params.data.additionalData.forEach(data => {temp.push(data.expiry_date === )})
                params.successCallback(temp);
            },
        };
    }, []);

    useEffect(() => {
        return () => {
            if (arrRowData?.length > 0) {
                const arrScrips = arrRowData?.map((each) => ({
                    exchangeId: getMktSegIdFromApiExchangeName(each?.exchange),
                    token: each?.scrip_token,
                    isSubscribe: false
                }));
                sendTouchlineRequest(arrScrips);
            } else { }
        };
    }, [arrRowData, dispatch]);

    const updateLiveFeed = useCallback((arrTouchLineData) => {
        const arrOrdersToUpdate = arrRowData?.filter((item) => item?.MktSegId === arrTouchLineData[TL_INDEX.SEGMENT_ID] && item?.scrip_token === arrTouchLineData[TL_INDEX.TOKEN]);
        if (arrOrdersToUpdate?.length > 0) {
            const arrUpdatedOrders = arrOrdersToUpdate?.map((item) => ({ ...item, ltp: arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE] }));
            if (arrUpdatedOrders?.length > 0) {
                ORDERS_GRID_REF?.current?.api?.applyTransaction({
                    update: arrUpdatedOrders
                });
            } else { }
        } else { }
    }, [arrRowData]);

    const [objScripsRequest, setObjScripsRequest] = useState({});
    const handleVisibleRows = useCallback(() => {
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]
            const arrVisibleRows = ORDERS_GRID_REF?.current?.api?.getRenderedNodes().map(item => {
                let id = getMktSegIdFromApiExchangeName(item?.data?.exchange) + '_' + item?.data?.scrip_token;
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({ exchangeId: getMktSegIdFromApiExchangeName(item?.data?.exchange), token: item?.data?.scrip_token, isSubscribe: true });

                }
                return { exchangeId: getMktSegIdFromApiExchangeName(item?.data?.exchange), token: item?.data?.scrip_token, isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);
            useDebounce(() => {
                const lastTickData = dispatch(getWfhTouchlineLastTick());
                arrVisibleRows?.forEach((eachScrip) => {
                    let selectedScrip = lastTickData[`${eachScrip?.exchangeId + '_' + eachScrip?.token}`];
                    if (selectedScrip?.length > 0) {
                        updateLiveFeed(selectedScrip);
                    }
                });

            }, 1000);
            return { ...objpreviosScripsCopy };
        });
    }, [dispatch, updateLiveFeed]);
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End

    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    useEffect(() => {
        //here we send request for only visible scrips
        if (arrRowData?.length > 0) {
            setTimeout(() => {
                handleVisibleRows();
            }, 1000);
        }
    }, [arrRowData, ordersTabKey, handleVisibleRows]);
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End


    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    const handleScrollEnd = async (e) => {
        if (e.direction === 'vertical') {
            handleVisibleRows();
        }
    };
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End

    const handleGtdScripsUnSubscription = useCallback(() => {
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'GTD order book');
    }, [objScripsRequest]);
    useUnload(() => {
        handleGtdScripsUnSubscription();
    });


    useWFHMessages('touchline', (e) => {
        updateLiveFeed([...e.detail]);
    });
    //Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --Start
    const handleApiCall = (bIsScrollToTop = false) => {
        switch (ordersTabKey) {
            case ORDERS_TABKEY.ALL_ORDERS:
                dispatch(getAllGtdOrders({ offSet: 1, limit: 20, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                dispatch(setCurrentPage(1));
                break;
            case ORDERS_TABKEY.OPEN_ORDERS:
                dispatch(getAllGtdOrders({ offSet: 1, limit: 20, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                dispatch(setCurrentPage(1));

                break;
            case ORDERS_TABKEY.COMPLETED_ORDERS:
                dispatch(getAllGtdOrders({ offSet: 1, limit: 20, orderStatus: ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS }));
                dispatch(setCurrentPage(1));

                break;
            default:
                break;
        }
        if (bIsScrollToTop) {
            ORDERS_GRID_REF.current?.api?.ensureIndexVisible(0, 'top');
        }
    };

    useEffect(() => {
        handleApiCall(true);
    }, [dispatch, ordersTabKey]);
    //Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --End


    const onGridReady = useCallback((params) => {
        params?.api?.updateGridOptions('rowDrag', false);
    }, []);

    const onRowGroupOpened = async (event) => {
        const rowNode = event.node;
        const rowData = rowNode.data;
        if (rowNode.expanded && rowData?.gateway_order_id) {
            const objPayload = {
                offSet: 1,
                limit: 1000,
                gtdOrderId: rowData?.gateway_order_id
            };
            const { status, data } = await _getGtdOrdersHistory(objPayload);
            if (status && data?.length > 0) {
                rowNode.setDataValue('trades', [...data]);
            } else { }
        } else { }
    };


    const handlePlaceOrder = () => {
        dispatch(handleModal([{ "ORDER_ENTRY_MODAL": true }]));
        dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.SINGLE_SCRIP } }));
        const objScrpinfo = { activeExchangeId: MARKET_SEGMENT_ID.NSE_CASH, isBuySell: 0, scripData: [] };
        dispatch(getScripOrderInfo(objScrpinfo));
    };

    const rowNode = useMemo(() => {

        return ORDERS_GRID_REF?.current && ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(0);
    }, []);
    const nRowHeight = rowNode?.rowHeight;

    useEffect(() => {
        if (arrRowData?.length > 0) {
            setNGridHeight(+arrRowData?.length * nRowHeight);
        }
    }, [arrRowData, nRowHeight, ORDERS_GRID_REF?.current]);

    const handleApiCallOnScroll = (offSet) => {
        let nMaxLimit = 0;
        if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
            nMaxLimit = objGTDMetaData?.total_records;
        } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
            nMaxLimit = objGTDMetaData?.open_records;
        } else if (ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) {
            nMaxLimit = objGTDMetaData?.completed_records;
        }

        if (arrRowData?.length < nMaxLimit && offSet > nCurrentPage) {
            dispatch(setCurrentPage(offSet));


            dispatch(getAllGtdOrders({ offSet: offSet, limit: ORDERS_LIMIT_IN_API, orderStatus: ordersTabKey === ORDERS_TABKEY.ALL_ORDERS ? ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS : ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS ? ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS : ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS })).then((objresp) => {
                bIsApiFiring = false;
            }
            ).catch((error) => {
                bIsApiFiring = false;
                console.log(error);
            });

        } else {
            bIsApiFiring = false;
        }

    };

    const handleScroll = () => {
        const gridApi = ORDERS_GRID_REF?.current?.api;
        const scrollPosition = gridApi?.getVerticalPixelRange()?.bottom;
        const rowNode = ORDERS_GRID_REF?.current && ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(0);
        const nRowHeight = rowNode?.rowHeight;
        setNGridHeight(+arrRowData?.length * nRowHeight);
        if (nGridHeight - scrollPosition <= nRowHeight * 5 && !bIsApiFiring) { //nRowHeight * 5===> call api when 5 row remaining on scroll
            bIsApiFiring = true;
            handleApiCallOnScroll(nCurrentPage + 1);
        }

    };
    const onGridPreDestroyed = useCallback((params) => {
        // this function gets called when the grdi before gets destroyed means getting removed from dom
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'spread orderbook');
    }, [objScripsRequest]);

    const defaultColProps = {
        minWidth: 180
    };
    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0 pt-1 px-3'>
                    <Col md={8}>
                        <BzTabs className='nav nav-tabs'>
                            <BzTab className='nav-link text-capitalize' onClick={() => onTabChange(ORDERS_TABKEY.ALL_ORDERS)} isActive={ordersTabKey === ORDERS_TABKEY.ALL_ORDERS} tabKey='all_orders'>{`All Orders(${objGTDMetaData?.total_records || 0})`}</BzTab>
                            <BzTab className='nav-link text-capitalize' onClick={() => onTabChange(ORDERS_TABKEY.OPEN_ORDERS)} isActive={ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS} tabKey='open_orders'>{`Open Orders(${objGTDMetaData?.open_records || 0})`}</BzTab>
                            <BzTab className='nav-link text-capitalize' onClick={() => onTabChange(ORDERS_TABKEY.COMPLETED_ORDERS)} isActive={ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS} tabKey='completed_orders'>{`Completed Orders(${objGTDMetaData?.completed_records || 0})`}</BzTab>
                        </BzTabs>
                    </Col>
                    <Col md={4}>
                        <div className='d-flex justify-content-end align-items-center pt-1'>
                            {/* Hari k:22-03-2024: BT-108447: create watchlist from list- start*/}
                            {/* {ordersTabKey === ORDERS_TABKEY.ALL_ORDERS ?
                                <div className={`d-flex align-items-center cursor-pointer ${gtdAllOrders?.length < 1 ? 'div-disabled' : ''}`}>
                                    <BzButton className='btn btn-sm btn-outline d-flex align-items-center ms-3' onClick={handleCreateWatchlist}>
                                        <div class="icon-12 icon-add icon-primary me-2"></div>
                                        <span className='font-medium'>Watchlist</span>
                                    </BzButton>
                                </div> : null} */}
                            {/* Hari k:22-03-2024: BT-108447: create watchlist from list- end*/}
                            {/* Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --Start */}
                            <div className='d-flex align-items-center cursor-pointer focus p-1 me-3 gap-2' onClick={handleApiCall?.bind(this, true)}>
                                <div className='icon-16 icon-refresh background-textual-link-withicon d-flex flex-shrink-0'></div>
                                <div className='font-medium font-size3 color-textual-link-withicon p-t-2'>Refresh</div>
                            </div>
                            {/* Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --End */}
                            {/* // Vaibhav SIngh: BT-102298: 09-02-24:Cancel All order button fixed:Start */}
                            {
                                ordersTabKey !== ORDERS_TABKEY.COMPLETED_ORDERS &&
                                <BzButton className='btn btn-outline btn-sm text-capitalize ms-3' onClick={onCancelOrder} disabled={isButtonDisabled || gtdOpenOrders?.length < 1}>Cancel All Order</BzButton>
                            }
                            {/* // Vaibhav SIngh: BT-102298: 09-02-24:Cancel All Order Buton FIxed:End */}
                        </div>
                    </Col>
                </Row>
                <Row className='g-0'>
                    {/* <div className='d-flex align-items-center'>
                        {activeFilters && Object.keys(activeFilters).length > 0 ? <div className='font-regular font-size4 color-text d-flex justify-content-center align-items-center p-3'>Filters:</div> : null}

                        {activeFilters && Object.keys(activeFilters).length > 0 &&
                            Object.keys(activeFilters).map((objFilterKey, i) =>
                                <div className='filters-chips-wrap'>
                                    <BzChip key={i} className='filter-chip me-2 text-capitalize'>{activeFilters[objFilterKey]}<div onClick={() => handleDelete(activeFilters[objFilterKey], i)} className='icon-close icon-dark ms-2'></div></BzChip>
                                </div>
                            )
                        }

                        {tempOrders.filter(Boolean).map((te, i) => {
                            return (
                                <>
                                    <div className='filters-chips-wrap'>
                                        <BzChip key={i} className=' me-2'>{te}<div onClick={() => handleDelete(te, i)} className='icon-10 icon-close icon-dark ms-2'></div></BzChip>
                                    </div>
                                </>
                            );
                        })}
                    </div> */}
                </Row>
            </Container>
            <LoginLoader spinner={bIsOrderApiPending} spinnerContent="Fetching Details" />

            {arrRowData?.length > 0 ? <div className='mt-2'>
                <BzMasterAgGrid
                    gridProfileType={MANAGE_COLUMNS_VIEW_TYPES.ORDER_GOOD_TILL_DATE_VIEW_TYPE}
                    onGridPreDestroyed={onGridPreDestroyed} defaultColProps={defaultColProps}
                    selectionColumnDef={selectionColumnDef}
                    onBodyScrollEnd={handleScrollEnd}
                    rowBuffer={1}
                    arrColumnData={arrColDef || []} arrRowData={arrRowData} ref={ORDERS_GRID_REF}
                    isMasterDetail={true} isSuppressMenu={false}
                    // gridDetailCellRenderer={gridDetailCellRenderer}
                    gridDetailCellRendererParams={detailCellRendererParams}
                    rowHeight={36} detailRowAutoHeight={true} className='ag-theme-alpine orders-ag-grid-wrapper'
                    getRowId={getRowId} onGridReady={onGridReady} isRowSelectable={isRowSelectable} rowSelection={rowSelection}
                    onRowGroupOpened={onRowGroupOpened} onRowSelected={onRowSelected}
                    isExternalFilterPresent={isExternalFilterPresent} doesExternalFilterPass={doesExternalFilterPass} rowClass='font-enlarge' //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
                    onBodyScroll={handleScroll}
                />
            </div> : !bIsOrderApiPending && arrRowData?.length <= 0 ?
                <div className='zero-state-alerts zero-state-alerts-xxl'>
                    <ZeroStates handleOnClick={handlePlaceOrder} heading="No orders available" icon='icon-64 icon-nodata mb-3 mrgauto' btnText="Place an order today" btnClass="btn btn-md btn-outline mt-2" />
                </div> : null}
        </>
    );
};

export default memo(GTD);
//Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End